// Inline pure helpers to avoid circular-import issues in tests
// (the common/util/util-formaters import chain triggers a circular dependency
//  via localStorage → util-helpers → util-constants → LocalStorage.get at module-eval time)
function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
        const negativeSign = amount < 0 ? "-" : "";
        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;
        return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
        console.log(e);
    }
}

function numberWithCommasToBack(n, def = null) {
    if (n) {
        let parts = n.toString().split(".");
        return Number(parts[0].replace(/,/g, "") + (parts[1] ? "." + parts[1] : (n.toString().includes(".") ? "." : "")));
    }
    return def ?? n;
}

export const MAX_OFFICE_OVERRIDES = 3;

export function officeOverridesFromData(data = {}) {
    return [1, 2, 3].reduce((memo, i) => {
        const id = data[`CreditLimitOfficeID${i}`];

        if (id) {
            memo.push({
                OfficeID: id,
                OfficeName: '',
                Amount: formatMoney(data[`CreditLimitOffice${i}`] ?? 0),
                errorOfficeID: '',
                errorAmount: ''
            });
        }

        return memo;
    }, []);
}

export function validateOfficeOverrideRows(rows) {
    const seenOfficeIDs = [];
    let isValid = true;

    const validatedRows = rows.map(row => {
        const next = {...row, errorOfficeID: '', errorAmount: ''};
        const hasOffice = !!next.OfficeID;
        const hasAmount = next.Amount !== '' && next.Amount !== null && next.Amount !== undefined;

        if (hasOffice && !hasAmount) {
            next.errorAmount = ['fields.errors.empty'];
            isValid = false;
        }

        if (!hasOffice && hasAmount) {
            next.errorOfficeID = ['fields.errors.empty'];
            isValid = false;
        }

        if (hasAmount && isNaN(numberWithCommasToBack(next.Amount))) {
            next.errorAmount = ['fields.errors.invalid_money_value'];
            isValid = false;
        }

        if (hasOffice) {
            if (seenOfficeIDs.includes(next.OfficeID)) {
                next.errorOfficeID = ['fields.errors.office_already_selected'];
                isValid = false;
            }

            seenOfficeIDs.push(next.OfficeID);
        }

        return next;
    });

    return {rows: validatedRows, isValid};
}

export function officeOverrideValuesFromRows(rows, isCreditLimitSet) {
    const filledRows = isCreditLimitSet
        ? rows.filter(it => !!it.OfficeID)
        : [];

    return [1, 2, 3].reduce((memo, i) => {
        const row = filledRows[i - 1];
        memo[`CreditLimitOfficeID${i}`] = row ? row.OfficeID : null;
        memo[`CreditLimitOffice${i}`] = row ? numberWithCommasToBack(row.Amount, 0) : null;
        return memo;
    }, {});
}
